// @flow

import * as types from '../actionTypes';
import genericNestedReducer, {
  genericNestedSelectorSet,
  useGenericNested,
} from './genericNested';
import type { waiverType } from '../../types';
import { waiver } from '../schemata';

const waivers = genericNestedReducer(types.GET_WAIVER_ASYNC);

export default waivers;

export const selectWaivers = genericNestedSelectorSet<waiverType>(
  waiver,
  state => state.waivers,
);

export const useWaivers = useGenericNested<waiverType>(
  waiver,
  state => state.waivers,
  state => state.categories,
);
